// src/components/Dashboard/Dashboard.jsx
import  { useState, useEffect } from 'react';

import Card from '../components/Card';
import ActivityItem from '../components/ActivityItem';

import './Dashboard.css';
import { BASE_URL } from '../utils/constants';

const Dashboard = () => {
  const [stats, setStats] = useState({
    totalOrders: 0,
    pendingPayments: 0,
    pendingDeliveries: 0,
    recentOrders: []
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await fetch(`${BASE_URL}/api/dashboard/stats`);
        console.log("Dashboard API response status:", response);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        setStats(data);
      } catch (err) {
        console.error('Dashboard fetch error:', err);
        setError('Failed to load dashboard data. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();

    // Optional: auto-refresh every 60 seconds
    const interval = setInterval(fetchDashboardData, 60000);
    return () => clearInterval(interval);
  }, []);

  // Map backend status to frontend-friendly labels/icons
  const getActivityProps = (order) => {
    const latestChange = order.deliveryStatusHistory?.[order.deliveryStatusHistory.length - 1];
    const status = latestChange?.status || order.deliveryStatus || order.paymentStatus;
    const changedBy = latestChange?.changedBy || 'System';
    const timeAgo = new Date(latestChange?.timestamp || order.updatedAt || order.createdAt).toLocaleString();

    let type = 'refresh'; // default
    let title = '';
    let subtitle = '';

    if (status === 'successful') {
      type = 'check';
      title = `Payment confirmed for Order #${order.reference}`;
      subtitle = `Amount: ZMK ${order.items.reduce((sum, i) => sum + i.totalCost, 0).toFixed(2)} • ${timeAgo}`;
    } else if (status === 'failed') {
      type = 'alert';
      title = `Payment failed - Order #${order.reference}`;
      subtitle = `Phone: ${order.phone} • ${timeAgo}`;
    } else if (status === 'shipped') {
      type = 'truck';
      title = `Order #${order.reference} shipped`;
      subtitle = `By ${changedBy} • Est. delivery: ${order.estimatedDeliveryDate ? new Date(order.estimatedDeliveryDate).toLocaleDateString() : 'TBD'} • ${timeAgo}`;
    } else if (status === 'delivered') {
      type = 'check';
      title = `Order #${order.reference} delivered`;
      subtitle = `To ${order.deliveryAddress?.fullName || 'Customer'} • ${timeAgo}`;
    } else if (status === 'processing') {
      type = 'refresh';
      title = `Order #${order.reference} is now processing`;
      subtitle = `Updated by ${changedBy} • ${timeAgo}`;
    } else {
      type = 'refresh';
      title = `Order #${order.reference} created`;
      subtitle = `Pending payment • ${timeAgo}`;
    }

    return { type, title, subtitle };
  };

  return (
    <div className="dashboard-page">
      {/* <Header /> */} {/* Uncomment if you want the header here */}

      <main className="main-content">
        <div className="container">
          <h1 className="page-title">Dashboard</h1>

          {error && <div className="error-message">{error}</div>}

          {loading ? (
            <div className="loading">Loading dashboard data...</div>
          ) : (
            <>
              <div className="stats-row">
                <Card>
                  <div className="stat-block">
                    <div className="stat-label">Total Orders</div>
                    <div className="stat-value">{stats.totalOrders}</div>
                  </div>
                </Card>
                <Card>
                  <div className="stat-block">
                    <div className="stat-label">Pending Payments</div>
                    <div className="stat-value">{stats.pendingPayments}</div>
                  </div>
                </Card>
                <Card>
                  <div className="stat-block">
                    <div className="stat-label">Pending Deliveries</div>
                    <div className="stat-value">{stats.pendingDeliveries}</div>
                  </div>
                </Card>
              </div>

              <Card title="Recent Activity">
                {stats.recentOrders.length === 0 ? (
                  <p style={{ textAlign: 'center', color: '#888' }}>No recent activity</p>
                ) : (
                  stats.recentOrders.map((order) => {
                    const { type, title, subtitle } = getActivityProps(order);
                    return (
                      <ActivityItem
                        key={order.reference}
                        type={type}
                        title={title}
                        subtitle={subtitle}
                      />
                    );
                  })
                )}
              </Card>
            </>
          )}
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
// import React from 'react';
// import Header from '../components/Header';
// import Card from '../components/Card';
// import ActivityItem from '../components/ActivityItem';
// import './Dashboard.css';

// const Dashboard = () => {
//   return (
//     <div className="dashboard-page">
//       {/* <Header /> */}

//       <main className="main-content">
//         <div className="container">
//           <h1 className="page-title">Dashboard</h1>

//           <div className="stats-row">
//             <Card>
//               <div className="stat-block">
//                 <div className="stat-label">Active Orders</div>
//                 <div className="stat-value">142</div>
//               </div>
//             </Card>
//             <Card>
//               <div className="stat-block">
//                 <div className="stat-label">Pending Pickup</div>
//                 <div className="stat-value">38</div>
//               </div>
//             </Card>
//             <Card>
//               <div className="stat-block">
//                 <div className="stat-label">In Transit</div>
//                 <div className="stat-value">91</div>
//               </div>
//             </Card>
//           </div>

//           <Card title="Recent Activity">
//             <ActivityItem
//               type="refresh"
//               title="Refund processed for Order #ORD-2024-001823"
//               subtitle="Amount: $89.50 • 8 minutes ago"
//             />
//             <ActivityItem
//               type="user"
//               title="Courier Mike Johnson assigned to 5 new deliveries"
//               subtitle="Route: Downtown District • 15 minutes ago"
//             />
//             <ActivityItem
//               type="check"
//               title="Batch delivery completed - 12 packages delivered"
//               subtitle="Courier: Emma Rodriguez • 23 minutes ago"
//             />
//             <ActivityItem
//               type="alert"
//               title="Delivery failed - Customer unavailable"
//               subtitle="Order #ORD-2024-001842 • 35 minutes ago"
//             />
//           </Card>
//         </div>
//       </main>
//     </div>
//   );
// };

// export default Dashboard;